import Two from "./Two";
// import React from "react";
// import grl from "../../assets/grl.jpg";
// import { Box, Typography } from "@mui/material";
// import { domain } from "../../constants/generalConstant";
// import One from "./One";
// import Three from "./Three";

export default function AboutUs() {
  return (
    <section className="">
      {/* <One /> */}
      <Two />
      {/* <Three /> */}
    </section>
  );
}
// This is a simple landing page component for a React application.
